import { useActionData, useFetcher, useLoaderData, useMatches, } from '@remix-run/react';
import * as _typedjson from './typedjson';
export const typedjson = (data, init = {}) => {
    let responseInit = typeof init === 'number' ? { status: init } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has('Content-Type')) {
        headers.set('Content-Type', 'application/json; charset=utf-8');
    }
    return new Response(stringifyRemix(data), {
        ...responseInit,
        headers,
    });
};
export function useTypedLoaderData() {
    const data = useLoaderData();
    return deserializeRemix(data);
}
export function useTypedActionData() {
    const data = useActionData();
    return deserializeRemix(data);
}
export function useTypedFetcher() {
    const fetcher = useFetcher();
    if (fetcher.data) {
        const newData = deserializeRemix(fetcher.data);
        fetcher.data = newData ?? undefined;
    }
    return fetcher;
}
export function useTypedRouteLoaderData(id) {
    const match = useMatches().find(match => match.id === id);
    if (!match)
        return undefined;
    return deserializeRemix(match.data);
}
export function stringifyRemix(data) {
    // prevent double JSON stringification
    let { json, meta } = _typedjson.serialize(data);
    if (json && meta) {
        if (json.startsWith('{')) {
            json = `${json.substring(0, json.length - 1)},\"__meta__\":${JSON.stringify(meta)}}`;
        }
        else if (json.startsWith('[')) {
            json = `{"__obj__":${json},"__meta__":${JSON.stringify(meta)}}`;
        }
    }
    return json;
}
export function deserializeRemix(data) {
    if (!data)
        return data;
    if (data.__obj__) {
        // handle arrays wrapped in an object
        return data.__meta__
            ? _typedjson.applyMeta(data.__obj__, data.__meta__)
            : data.__obj__;
    }
    else if (data.__meta__) {
        // handle object with __meta__ key
        // remove before applying meta
        const meta = data.__meta__;
        delete data.__meta__;
        return _typedjson.applyMeta(data, meta);
    }
    return data;
}
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 *
 * @see https://remix.run/api/remix#redirect
 */
export const redirect = (url, init = 302) => {
    let responseInit = init;
    if (typeof responseInit === 'number') {
        responseInit = { status: responseInit };
    }
    else if (typeof responseInit.status === 'undefined') {
        responseInit.status = 302;
    }
    let headers = new Headers(responseInit.headers);
    headers.set('Location', url);
    return new Response(null, {
        ...responseInit,
        headers,
    });
};
